import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shared-core-floating-menu-item',
  template: `<ng-content />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingMenuItemComponent {}
